import { render, staticRenderFns } from "./SimpleExamination.vue?vue&type=template&id=3d7faa0c&"
import script from "./SimpleExamination.vue?vue&type=script&lang=ts&"
export * from "./SimpleExamination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports